import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NotificacaoTO } from "src/app/data/schema/Notifications/NotificacaoTO";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root"
})
export class ApiNotificacaoService {
    constructor(private http: HttpClient) {}

    getNotifications = (): Observable<NotificacaoTO[]> => {
        return this.http.get<NotificacaoTO[]>(`${environment.notifications.url}/api/v1/Notification`);
    };
}
